import authAxios from "../axios-instance/authAxios";

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const SubscriptionApi = {
    getSubscription,
    getMySubscriptions,
    startSubscription,
    changeCard,
    runAction,
}

async function getSubscription({ params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/subscriptions`, { params });
}

async function getMySubscriptions() {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/subscriptions/mine`);
}

async function startSubscription({ body }) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/subscriptions`, body);
}

async function changeCard({ id, body }) {
    return await authAxios.put(`${MAIN_API_HOST}/v2/public/subscriptions/${id}/card`, body);
}

// action: cancel | resume | refund
async function runAction({ id, action }) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/subscriptions/${id}/${action}`, {});
}
